import { GetAllSites } from '@/api/fe-api/view/queries/get-all-sites';
import { Checkbox } from '@/components/form/inputs/checkbox';
import { Loading } from '@/components/ui/old/Loading';
import { siteLabel } from '@/utils/format/customer';

export type MultiSelectAssetProps = {
  value: string[];
  onChange: (value: string[]) => void;
  error?: string;
};

export function MultiSelectAsset({
  error,
  value,
  onChange,
}: MultiSelectAssetProps) {
  const data = GetAllSites.useQuery();
  if (data.isLoading) {
    return <Loading />;
  }

  return (
    <div>
      <div className="grid grid-cols-2 gap-2">
        {data.data?.map((asset) => (
          <div key={asset.id} className="flex items-center space-x-2">
            <Checkbox
              id={asset.id}
              checked={value.includes(asset.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  onChange([...value, asset.id]);
                } else {
                  onChange(value.filter((id) => id !== asset.id));
                }
              }}
            />
            <label
              htmlFor={asset.id}
              className={value.includes(asset.id) ? undefined : 'opacity-50'}
            >
              {siteLabel(asset.fullFrontendId)}
            </label>
          </div>
        ))}
      </div>
      {error ? <div className="my-2 text-xs text-red-500">{error}</div> : null}
    </div>
  );
}
